import React, { useState, useCallback } from 'react';
import PropTypes from 'prop-types';
import withStyles from '@material-ui/core/styles/withStyles';
import { Box, Grid, MenuItem, Typography } from '@material-ui/core';
import * as turf from '@turf/turf';

import SimpleHeading from '../SimpleHeading';

import {
    Alert,
    Autocomplete,
    ToggleButton,
    ToggleButtonGroup
} from '@material-ui/lab';

import isEqual from 'lodash/isEqual';

import TextField from '../../../../Common/UI/TextField';

import axios from 'axios';
import debounce from 'lodash/debounce';

import InputLabel from '../../../../Common/UI/InputLabel';

import { MAIN_MAP } from '../../../../../redux/map/Constants';

import DrawnAreaInfoCard from './DrawnAreaInfoCard';
import {
    setAreaFacetValue,
    setAreaGeojson,
    validateAreaFacetValueAsync
} from '../../../../../redux/search_area/Actions';
import { useSelector, useDispatch } from 'react-redux';

const areaUnits = ['ha', 'km2', 'ac'];

function FixedSearchAreaInput({ featureKey, reducerName, reducerAreaKey }) {
    const [options, setOptions] = useState([]);

    const drawModule = useSelector(state => state[MAIN_MAP].drawModule);
    const maxArea = useSelector(state => state.user.features[featureKey].maxArea);
    const { defaultAreaUnit } = useSelector(state => state.user.prefs);
    const geojson = useSelector(state => state[reducerName][reducerAreaKey].geojson);
    const facetValue = useSelector(
        state => state[reducerName][reducerAreaKey].facetValue
    );
    const facetValid = useSelector(
        state => state[reducerName][reducerAreaKey].facetValid
    );
    const facet = useSelector(state =>
        state.lookups.uiData.facetChoices.find(
            el => el.id === state[reducerName][reducerAreaKey].facetId
        )
    );

    const dispatch = useDispatch();
    const dispatchSetAreaFacetValue = value =>
        dispatch(setAreaFacetValue(reducerName, value));
    const dispatchValidateAreaValueAsync = (facetId, value) =>
        dispatch(validateAreaFacetValueAsync(reducerName, facetId, value));

    const debouncedAutocomplete = useCallback(
        debounce((facetId, facetValue) => {
            axios
                .get(`/api/facets/${facetId}/autocomplete?value=${facetValue}`)
                .then(response => {
                    setOptions(response.data);
                })
                .catch(error => {
                    if (axios.isCancel(error)) {
                        console.log('cancel');
                    } else {
                        console.error(error);
                    }
                });
        }, 500),
        []
    );

    function handleAutocompleteInputChange(event, value) {
        dispatchSetAreaFacetValue(value);
        dispatchValidateAreaValueAsync(facet.id, value);
        debouncedAutocomplete(facet.id, value);
    }

    function handleAutocompleteChange(event, value) {
        dispatchSetAreaFacetValue(value);
        dispatchValidateAreaValueAsync(facet.id, value);
    }

    return (
        <div>
            <Grid container spacing={2} alignContent="center" alignItems="center">
                <Grid item xs={4}>
                    <InputLabel label={facet.name} />
                </Grid>
                <Grid item xs={8}>
                    <Autocomplete
                        fullWidth
                        renderInput={params => (
                            <TextField
                                inputRef={params.InputProps.ref}
                                inputProps={params.inputProps}
                                placeholder={facet.name}
                                fullWidth
                            />
                        )}
                        freeSolo
                        getOptionLabel={option => option}
                        options={options}
                        // groupBy={option => fields[option].category}
                        value={facetValue}
                        onChange={handleAutocompleteChange}
                        onInputChange={handleAutocompleteInputChange}
                        disableClearable
                    />
                </Grid>
            </Grid>
            {geojson && facetValue && facetValid && (
                <DrawnAreaInfoCard
                    value={turf.area(geojson.geometry)}
                    label="Area"
                    defaultAreaUnit={
                        areaUnits.includes(defaultAreaUnit) ? defaultAreaUnit : 'ha'
                    }
                    areaUnits={areaUnits}
                />
            )}
        </div>
    );
}

export default FixedSearchAreaInput;
